import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { backgroundColors } from 'config'

const Button = (props) => (
  <InnerButton onClick={props.onClick} className={props.className} bgColor={backgroundColors.normalRight}>
    <span>{props.text}</span>
    {props.children}
  </InnerButton>
)

Button.defaultProps = {
  enable: true
}

Button.propTypes = {
  text: PropTypes.string,
  color: PropTypes.string,
  onClick: PropTypes.func
}

const InnerButton = styled.button`
  text-transform: uppercase;
  cursor: pointer;
  border: none;
  background-color: transparent;
  font-size: 14px;
  font-weight: bold;
  line-height: 14px;
  box-sizing: border-box;
  padding: 17px;
  width: 100%;
  transition: all 0.2s ease;
  height: 48px;
  font-family: 'Nunito';
  color: #006736;
  position: relative;
  background-image: ${({bgColor}) => bgColor};
  border-radius: 0px;
  & > span {
    position: relative;
  }

  &:active, &:hover {
    color: #fff;

    &:before {
      background-image: ${({bgColor}) => bgColor};
    }
  }

  &:before {
    background-color: ${({ bg }) => bg || '#EFEFEF'};
    height: calc(100% - 2px);
    width: calc(100% - 2px);
    position: absolute;
    top: 1px;
    left: 1px;
    content: '';
  }
`

export default Button



// WEBPACK FOOTER //
// ./src/components/Button/index.js